<script lang="ts" setup>
import { computed, onMounted } from "vue";

// Properties
const props = defineProps({
    modelValue: {
        type: [Array, String, Boolean, Number],
        default: "",
    },
    value: {
        type: [String, Boolean, Number],
        default: "",
    },
    initialError: {
        type: String,
        default: "",
    },
    required: {
        type: Boolean,
        default: false,
    },
    lineHeight: {
        type: String,
        default: "leading-none",
    },
});

// Data
const emit = defineEmits(["update:modelValue", "change"]);
let error = "";

const model = computed({
    get() {
        return props.modelValue;
    },
    set(value) {
        validateInput(value);
        return emit("update:modelValue", value);
    },
});

// Functions
function validateInput(value: any) {
    error = "";
    if (props.required) {
        if (value.length <= 0) {
            error = "Field is required";
        }
    }
}

function onChange(event: any) {
    validateInput(event.target.value);
    emit("change", event.target.value, error);
}

onMounted(() => {
    error = props.initialError;
});
</script>

<template>
    <label class="py-1" :class="lineHeight">
        <input
            v-model="model"
            type="checkbox"
            :value="value"
            :required="required"
            class="custom-checkbox"
            @change="onChange"
        />
        <slot></slot>
    </label>
</template>

<style scoped>
label {
    display: grid;
    grid-template-columns: 1em auto;
    gap: 0.8em;
    cursor: pointer;
}

.custom-checkbox {
    /* Add if not using autoprefixer */
    -webkit-appearance: none;
    appearance: none;
    /* For iOS < 15 to remove gradient background */
    background-color: #fff;
    /* Not removed via appearance */
    margin: 0;

    font: inherit;
    color: red;
    width: 1.15em;
    height: 1.15em;
    border: 0.15em solid #adacac;
    border-radius: 0.15em;
    transform: translateY(-0.075em);

    display: grid;
    place-content: center;
    cursor: pointer;
}

.custom-checkbox:checked {
    @apply h-[1.15em] w-[1.15em] content-none;
    box-shadow:
        inset 0.1em 0.1em #ffffff,
        inset -0.1em -0.1em #ffffff;
    background-color: #007cba;
}

.custom-checkbox:hover {
    border-color: #757575;
}

.custom-checkbox:focus {
    border-color: #007cba;
}

.custom-checkbox:active {
    border-color: #979797;
    background-color: #01293a;
    box-shadow:
        inset 0.1em 0.1em #ffffff,
        inset -0.1em -0.1em #ffffff;
}
</style>
